import { render, staticRenderFns } from "./FavoriteDishes.vue?vue&type=template&id=92f66c1c&"
import script from "./FavoriteDishes.vue?vue&type=script&lang=js&"
export * from "./FavoriteDishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports